import axios from "axios";
// let locationorigin = window.location.origin;
// let regexpatt = /\W?\d*$/;
// let windowobj = locationorigin.replace(regexpatt, "");

const apiClient = axios.create({
  baseURL:
    process.env.NODE_ENV == "development"
      ? `${process.env.VUE_APP_LOCAL_API_ORIGIN}`
      : `${process.env.VUE_APP_LIVE_API_ORIGIN}`,
  headers: { Pragma: "no-cache", "Cache-Control": "no-store" }
});

const apiClientV2 = axios.create({
  baseURL:
    process.env.NODE_ENV == "development"
      ? `${process.env.VUE_APP_LOCAL_API_V2_ORIGIN}`
      : `${process.env.VUE_APP_LIVE_API_V2_ORIGIN}`,
  headers: {
    Pragma: "no-cache",
    "Cache-Control": "no-store"
  }
});
//apiClient.header = { 'Cache-control': 'no-store' }

export default {
  miniResults(email) {
    return apiClient.get("/dashboard.class.php?get=result&cemail=" + email);
  },

  maxiResults(email) {
    return apiClient.get("/dashboard.class.php?get=results&cemail=" + email);
  },

  upSchedule(email) {
    return apiClient.get(
      "/dashboard.class.php?get=schedulesup&cemail=" + email
    );
  },

  pastSchedule(email) {
    return apiClient.get(
      "/dashboard.class.php?get=schedulespast&cemail=" + email
    );
  },

  addSchedules(scheduleObj) {
    return apiClient.post("/dashboard.class.php", {
      action: "Add-Schedule",
      scheduleObj
    });
  },
  getOverallGraph(useremail) {
    return apiClient.get(
      "/dashboard.class.php?get=overallgraph&uemail=" + useremail
    );
  },
  getSubjectGraph(useremail) {
    return apiClient.get(
      "/dashboard.class.php?get=subjectgraph&uemail=" + useremail
    );
  },
  getLeaderboard(query) {
    return apiClientV2.get(`/leaderboard?${query}`);
  },
  getLeaderboardI(institution) {
    return apiClient.post("/dashboard.class.php", {
      action: "leaderboardI",
      institution: institution
    });
  },
  saveProfile(profileObj) {
    return apiClient.post("/dashboard.class.php", {
      action: "Update-Profile",
      profileObj
    });
  },
  getTestspaces(email) {
    return apiClient.post("/dashboard.class.php", {
      action: "get-testspaces",
      email
    });
  },
  getOrgCandidateTestspaces(email, candidate_id, organization_id) {
    return apiClient.post("/organization.class.php", {
      action: "get-org-candidate-testspaces",
      email,
      candidate_id,
      organization_id
    });
  },
  getTestspace(codeObj) {
    return apiClient.post("/dashboard.class.php", {
      action: "get-single-testspace",
      codeObj
    });
  },
  getCompetitions(email) {
    return apiClient.post("/dashboard.class.php", {
      action: "get-competitions",
      email
    });
  },
  getCompetition(codeObj) {
    return apiClient.post("/dashboard.class.php", {
      action: "get-single-competition",
      codeObj
    });
  },
  getPremiumplans(email) {
    return apiClient.post("/dashboard.class.php", {
      action: "get-premium-plans",
      email
    });
  },
  onRenew(trackid) {
    return apiClient.post("/dashboard.class.php", {
      action: "on-renew",
      trackid
    });
  },
  offRenew(trackid) {
    return apiClient.post("/dashboard.class.php", {
      action: "off-renew",
      trackid
    });
  },
  getAmbStat(email) {
    return apiClient.post("/dashboard.class.php", {
      action: "get-amb-stat",
      email
    });
  },
  setAmb(updateObj) {
    return apiClient.post("/dashboard.class.php", {
      action: "update-amb-profile",
      updateObj
    });
  },
  setAmbacct(updateObj) {
    return apiClient.post("/dashboard.class.php", {
      action: "update-amb-acct",
      updateObj
    });
  },
  setreqPayout(reqObj) {
    return apiClient.post("/dashboard.class.php", {
      action: "request-payout",
      reqObj
    });
  },
  setCancelpayout(cancelObj) {
    return apiClient.post("/dashboard.class.php", {
      action: "cancel-payout",
      cancelObj
    });
  },
  getUsermetrics(trackid, limit) {
    return apiClient.post("/dashboard.class.php", {
      action: "get-user-metrics",
      trackid,
      limit
    });
  },
  getReferrals(email) {
    return apiClient.post("/dashboard.class.php", {
      action: "get-referrals",
      email
    });
  },

  getNotifications() {
    return apiClientV2.get("/notifications/all");
  },

  getSingleNotification(id) {
    return apiClientV2.get(`/notifications/one/${id}`);
  },

  updateNotiReaders(noti){
    return apiClientV2.post("/notifications/user", noti);
  },
  getOrgLatestScores(org_id) {
    return apiClient.post("/organization.class.php", {
      action: "get-latest-scores",
      org_id
    });
  },
  getOrgUpcomingOngoingTestspaces(org_id) {
    return apiClient.post("/organization.class.php", {
      action: "get-upcoming-ongoing-testspaces",
      org_id
    });
  },
  getStudySuggestion(user_id) {
    return apiClientV2.get(`/studysuggestion/${user_id}`);
  },
  getStudyNote(payload) {
    return apiClientV2.post(`/studyroom`, payload);
  },
  getSingleStudyRoom(id) {
    return apiClientV2.get(`/studyroom/${id}`);
  },
  deleteSingleStudyRoom(id) {
    return apiClientV2.delete(`/studyroom/${id}`);
  },
  getStudyHistory(user_id) {
    return apiClientV2.get(`/studyhistory/${user_id}`);
  },

};
